import React, { useCallback, useState } from 'react';

import { Button, Tabs } from 'antd';

import { Groups } from 'v2/components/Pages/AccessControl/Groups';
import TopPage from 'v2/components/Shared/TopPage';
import type { Group, User } from 'v2/interfaces/access-control';
import accessControlService from 'v2/services/access-control';

import FormGroup from './components/FormGroup';
import FormUser from './components/FormUser';
import { useAccessPolicyUsers } from './components/useAccessPolicyUsers';
import Users from './components/Users';

const AccessPolicy: React.FC = () => {
  const [tab, setTab] = useState('groups');
  const [openFormUser, setOpenFormUser] = useState(false);
  const [openFormGroup, setOpenFormGroup] = useState(false);
  const [currentGroup, setCurrentGroup] = useState<Group | null>(null);
  const [currentUser, setCurrentUser] = useState<User | null>(null);

  const { refetch } = useAccessPolicyUsers();

  const handleGroupOpenCreate = useCallback(() => {
    setOpenFormGroup(true);
    setCurrentGroup(null);
  }, []);

  const handleGroupOpenEdit = useCallback((group: Group) => {
    setOpenFormGroup(true);
    setCurrentGroup(group);
  }, []);

  const handleGroupComplete = useCallback(() => {
    setOpenFormGroup(false);
    setCurrentGroup(null);

    setTimeout(() => {
      accessControlService.loadGroups().subscribe();
    }, 1000);
  }, []);

  const handleGroupCancel = useCallback(() => {
    setOpenFormGroup(false);
    setCurrentGroup(null);
  }, []);

  const handleUserOpenCreate = useCallback(() => {
    setOpenFormUser(true);
    setCurrentUser(null);
  }, []);

  const handleUserOpenEdit = useCallback((user: User) => {
    setOpenFormUser(true);
    setCurrentUser(user);
  }, []);

  const handleUserComplete = useCallback(() => {
    setOpenFormUser(false);
    setCurrentUser(null);
    refetch();
  }, [refetch]);

  const handleUserCancel = useCallback(() => {
    setOpenFormUser(false);
    setCurrentUser(null);
  }, []);

  const tabItems = [
    {
      key: 'groups',
      label: 'Grupos',
      children: <Groups onEdit={handleGroupOpenEdit} />
    },
    {
      key: 'users',
      label: 'Usuários',
      children: <Users onEdit={handleUserOpenEdit} />
    }
  ];

  return (
    <>
      {openFormGroup && (
        <FormGroup current={currentGroup} onComplete={handleGroupComplete} onCancel={handleGroupCancel} />
      )}

      {openFormUser && <FormUser current={currentUser} onComplete={handleUserComplete} onCancel={handleUserCancel} />}

      <TopPage
        title='Controle de Acesso'
        extra='Adicione um gerente para administrar algumas funções administrativas dos seus produtos, afiliados e campanha.'
        additionalContent={
          <div className='flex flex-wrap gap-2'>
            <Button color='default' variant='filled' onClick={handleGroupOpenCreate}>
              Adicionar Grupo
            </Button>
            <Button type='primary' onClick={handleUserOpenCreate}>
              Adicionar Usuário
            </Button>
          </div>
        }
      />

      <Tabs activeKey={tab} onChange={setTab} items={tabItems} className='pb-4' />
    </>
  );
};

export default AccessPolicy;
